import reduce from 'lodash/reduce';
import replace from 'lodash/replace';

import {TemplateRCDataFromRequest, TranslateValue} from 'core/RateConfirmation/types';
import {getTranslateSomeTitle} from 'core/RateConfirmation/modules/translate';

type ResultDesc = {
    contactName: TranslateValue;
    contactPhone: TranslateValue;
    contactEmail: TranslateValue;
    sentBy: TranslateValue;
};

export const getDescInfo = (data: TemplateRCDataFromRequest): ResultDesc => {
    const titleContactDispatcher = getTranslateSomeTitle({data, translateTitle: 'Contact person:'});
    const titlePhone = getTranslateSomeTitle({data, translateTitle: 'Phone Number:'});
    const titleEmail = getTranslateSomeTitle({data, translateTitle: 'E-mail:'});
    const titleSentBy = getTranslateSomeTitle({data, translateTitle: 'Sent by:'});
    const sentByTemplate = getTranslateSomeTitle({data, translateTitle: '%dispatcherName% on %rcDate% %rcTime%'});

    const {contact_dispatcher, dispatcher_name, rc_date, rc_time} = data;

    const sentBy = reduce(sentByTemplate.split('%'), (prev, current) => {
        let prevConcat = prev;
        let currentConcat = current;
        if (prev === 'dispatcherName') {
            prevConcat = replace(prev, 'dispatcherName', `${dispatcher_name}`);
        }
        if (current === 'rcDate') {
            currentConcat = replace(current, 'rcDate', `${rc_date}`);
        }
        if (current === 'rcTime') {
            currentConcat = replace(current, 'rcTime', `${rc_time}`);
        }
        return prevConcat + currentConcat;
    });

    return {
        contactName: {
            title: titleContactDispatcher,
            value: contact_dispatcher?.name,
        },
        contactPhone: {
            title: titlePhone,
            value: contact_dispatcher?.phone,
        },
        contactEmail: {
            title: titleEmail,
            value: contact_dispatcher?.email,
        },
        sentBy: {
            title: titleSentBy,
            value: sentBy,
        },
    };
};
